import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IAzureActiveDirectoryConnectionInfoHolder, IResult } from "../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class EntraIdConnectionService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/azure-active-directory`;
  }
  constructor(
    private http: HttpClient
  ) {}

  getConnection(instanceId: string): Observable<IAzureActiveDirectoryConnectionInfoHolder> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.get<IAzureActiveDirectoryConnectionInfoHolder>(baseRoute);
  }

  testConnection(instanceId: string, connection: IAzureActiveDirectoryConnectionInfoHolder): Observable<IResult> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post<IResult>(`${baseRoute}/test`, connection);
  }

  upsertConnection(instanceId: string, connection: IAzureActiveDirectoryConnectionInfoHolder): Observable<any> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.put<any>(baseRoute, connection);
  }
}
